import { createIcon } from '@chakra-ui/react';

export const EyeCloseIcon = createIcon({
  displayName: 'EyeCloseIcon',
  path: (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
       // width="12"
       // height="13"
        viewBox="0 0 12 13"
        fill="none"
      >
        <g clipPath="url(#clip0_1202_17763)">
          <mask
            id="mask0_1202_17763"
            //style="mask-type:luminance"
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="12"
            height="13"
          >
            <path d="M12 0.5H0V12.5H12V0.5Z" fill="white" />
          </mask>
          <g mask="url(#mask0_1202_17763)">
            <path
              d="M4.73496 8.13995C4.63996 8.13995 4.54496 8.10495 4.46996 8.02995C4.05996 7.61995 3.83496 7.07495 3.83496 6.49995C3.83496 5.30496 4.80496 4.33496 5.99995 4.33496C6.57495 4.33496 7.11995 4.55996 7.52995 4.96996C7.59995 5.03996 7.63995 5.13496 7.63995 5.23496C7.63995 5.33496 7.59995 5.42996 7.52995 5.49996L4.99996 8.02995C4.92496 8.10495 4.82996 8.13995 4.73496 8.13995ZM5.99995 5.08496C5.21995 5.08496 4.58496 5.71995 4.58496 6.49995C4.58496 6.74995 4.64996 6.98995 4.76996 7.19995L6.69995 5.26996C6.48995 5.14996 6.24995 5.08496 5.99995 5.08496Z"
              fill="#56527A"
            />
            <path
              d="M2.79992 9.75525C2.71492 9.75525 2.62492 9.72525 2.55492 9.66525C2.01992 9.21025 1.53992 8.65025 1.12992 8.00025C0.599922 7.17525 0.599922 5.83025 1.12992 5.00023C2.34992 3.09023 4.12492 1.99023 5.99993 1.99023C7.09993 1.99023 8.18493 2.37023 9.13493 3.08523C9.29993 3.21023 9.33493 3.44523 9.20993 3.61023C9.08493 3.77523 8.84993 3.81023 8.68493 3.68523C7.86493 3.06523 6.93493 2.74023 5.99993 2.74023C4.38492 2.74023 2.83992 3.71023 1.75992 5.40523C1.38492 5.99025 1.38492 7.01025 1.75992 7.59525C2.13492 8.18025 2.56492 8.68525 3.03992 9.09525C3.19492 9.23025 3.21492 9.46525 3.07992 9.62525C3.00992 9.71025 2.90492 9.75525 2.79992 9.75525Z"
              fill="#56527A"
            />
            <path
              d="M5.99932 11.0098C5.33432 11.0098 4.6843 10.8747 4.0593 10.6097C3.8693 10.5297 3.7793 10.3098 3.8593 10.1198C3.9393 9.92975 4.1593 9.83975 4.3493 9.91975C4.8793 10.1448 5.43432 10.2598 5.99432 10.2598C7.60932 10.2598 9.15432 9.28975 10.2343 7.59475C10.6093 7.00975 10.6093 5.98975 10.2343 5.40476C10.0793 5.15976 9.90932 4.92475 9.72932 4.70475C9.59932 4.54475 9.62432 4.30976 9.78432 4.17476C9.94432 4.04476 10.1793 4.06475 10.3143 4.22975C10.5093 4.46975 10.6993 4.72975 10.8693 4.99975C11.3993 5.82475 11.3993 7.16975 10.8693 7.99975C9.64932 9.90975 7.87432 11.0098 5.99932 11.0098Z"
              fill="#56527A"
            />
            <path
              d="M6.3448 8.63517C6.1698 8.63517 6.0098 8.51017 5.9748 8.33017C5.9348 8.12517 6.0698 7.93017 6.2748 7.89517C6.8248 7.79517 7.2848 7.33517 7.3848 6.78517C7.4248 6.58017 7.6198 6.45017 7.8248 6.48517C8.0298 6.52517 8.1648 6.72017 8.1248 6.92517C7.9648 7.79017 7.2748 8.47517 6.4148 8.63517C6.3898 8.63017 6.3698 8.63517 6.3448 8.63517Z"
              fill="#56527A"
            />
            <path
              d="M0.999727 11.8754C0.904727 11.8754 0.809727 11.8404 0.734727 11.7654C0.589727 11.6204 0.589727 11.3804 0.734727 11.2354L4.46973 7.50035C4.61473 7.35535 4.85473 7.35535 4.99973 7.50035C5.14471 7.64535 5.14471 7.88535 4.99973 8.03035L1.26473 11.7654C1.18973 11.8404 1.09473 11.8754 0.999727 11.8754Z"
              fill="#56527A"
            />
            <path
              d="M7.26437 5.60975C7.16937 5.60975 7.07438 5.57475 6.99938 5.49973C6.85438 5.35473 6.85438 5.11473 6.99938 4.96973L10.7344 1.23473C10.8794 1.08973 11.1194 1.08973 11.2644 1.23473C11.4094 1.37973 11.4094 1.61973 11.2644 1.76473L7.52938 5.49973C7.45438 5.57475 7.35937 5.60975 7.26437 5.60975Z"
              fill="#56527A"
            />
          </g>
        </g>
        <defs>
          <clipPath id="clip0_1202_17763">
            <rect width="12" height="12" fill="white" transform="translate(0 0.5)" />
          </clipPath>
        </defs>
      </svg>
    </>
  ),
});
